module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-nuxt-ssr-168.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vux-nuxt-ssr.md
// module id = 583
// module chunks = 195